<div class="u-card">
    <form class="c-entry-group" [formGroup]="form" [appBuildFormFromFields]="passwordFields">
        @for (field of passwordFields; track field.key) {
            <ng-container coreDynamicField 
                [field]="field" 
                [value]="''" 
                [mode]="ModalMode.EDIT"
                [errors]="getFieldErrors(field.key.toString())"
                (valueChange)="onValueChange(field.key, $event)"
                (onBlurEvent)="onBlur(field.key)">
            </ng-container>
        }
        <div class="u-flex--wrap u-push-t--xl">
            <core-generic-button 
                [config]="saveButtonConfig()" 
                (buttonClick)="onSave()">
            </core-generic-button>
        </div>
    </form>
</div>